import { Platform, usePlatform } from '@tofu/platform';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import { FanForgeStatusBar } from './fanforge-status-bar';
import { useIntentRedirect } from '../hooks/use-intent-redirect';

export const AppFrame = ({ children }: { children: React.ReactNode }) => {
  const isDiscord = usePlatform().platform.platform === Platform.DiscordActivity;
  const location = useLocation();
  const { pathname } = location;
  useIntentRedirect();

  const pathsWithFanForgeStatusBar = [
    '/gimmecat-legacy',
    '/mafia',
    '/partee',
    '/caketower',
    '/ffchess',
    '/bubbo',
    '/juicejam',
  ];
  const showFanForgeStatusBar = pathsWithFanForgeStatusBar.some((path) => pathname.includes(path));

  return (
    <div
      className={clsx(
        'w-full h-screen box-sizing-border relative',
        isDiscord && 'pt-[12%] md:pt-0',
        'bg-dark overflow-y-scroll'
      )}
      id="app-frame"
    >
      {showFanForgeStatusBar && <FanForgeStatusBar />}
      {children}
    </div>
  );
};
